// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/history/stylesheet/style.scss
 ** module id = 446
 ** module chunks = 1
 **/